/**
 * 「지금 더 낼 수 있는 날」 (2026-09-01 · 파이프라인 하네스 판 F).
 *
 * ★★★ **`remaining` 과 `available` 은 다른 값이다.**
 *    · `remaining` = 부여 − **사용** — 담당자 화면(「연차 관리」)이 쓰던 뜻
 *    · `available` = 잔여 − **신청중** — 직원 화면이 「잔여」로 크게 보여 주던 값
 *
 *    종전에는 서버가 화면마다 다른 규칙으로 세어 **같은 이름이 두 뜻**이었다. 이제 서버가
 *    둘을 갈라 주고, 직원 화면은 `available` 을 보여야 **종전과 같은 숫자**가 된다.
 *
 * ★ 옛 서버는 `available` 을 안 준다 — 그때는 `remaining` 이 이 뜻이었으므로 그것으로 떨어진다.
 *   그래서 **배포 순서에 상관없이** 화면의 숫자가 안 바뀐다.
 * ★ `api/hr` 가 아니라 `lib` 에 둔다 — API 모듈을 통째로 mock 하는 검사가 여럿이라, 순수
 *   함수가 거기 살면 mock 마다 이 이름을 더해야 한다(실제로 검사 12개가 그렇게 깨졌다).
 */
export const leaveAvailable = (
  a?: { available?: number | null; remaining?: number | null } | null,
): number | null => a?.available ?? a?.remaining ?? null;
